import { ReactNode } from 'react';
import { MAIN_PACE_TASK_IDs } from '@symfa-inc/providence-types';
import { ColumnsType } from 'antd/lib/table/interface';
import {
  projectCategoryRender,
  projectPaceTaskDataRender,
  readOnlyInputNumberRender,
} from '@core/utils/methods';
import { SiteBrowse } from '@models/interfaces';
import { Browse } from '@models/types';

export const SOF_TOOL_BROWSE_COLUMNS: ColumnsType<Browse> = [
  {
    title: 'FA Location Number',
    dataIndex: 'site',
    key: 'FALocationNumber',
    sorter: true,
    render: (site: SiteBrowse): ReactNode =>
      readOnlyInputNumberRender(site?.FALocationNumber),
  },
  {
    title: 'Legacy Site ID',
    dataIndex: 'site',
    key: 'legacySiteID',
    sorter: true,
    render: (site: SiteBrowse): ReactNode => site?.legacySiteID,
  },
  {
    title: 'Oracle Project Number',
    dataIndex: 'categories',
    key: 'oracleProjectNumber',
    sorter: true,
    render: projectCategoryRender({
      field: 'oracleProjectNumber',
    }),
  },
  {
    title: 'PACE Project Number',
    dataIndex: 'categories',
    key: 'PACEProjectNumber',
    sorter: true,
    render: projectCategoryRender({
      field: 'PACEProjectNumber',
    }),
  },
  {
    title: 'IWM Job Number',
    key: 'IWMJobNumber',
    dataIndex: 'categories',
    render: projectCategoryRender({
      field: 'IWMJobNumber',
    }),
    sorter: true,
  },
  {
    title: 'SS014 Actual Date',
    key: 'SS014ActualDate',
    dataIndex: 'projectPaceTaskData',
    sorter: true,
    width: 200,
    render: projectPaceTaskDataRender({
      id: MAIN_PACE_TASK_IDs.scopingComplete,
      field: 'actualDate',
    }),
  },
  {
    title: 'Site Number',
    dataIndex: 'site',
    key: 'siteNumber',
    sorter: true,
    render: (site: SiteBrowse): ReactNode => site?.siteNumber,
  },
];
